import React, { useEffect, useState } from "react";
import { useParams } from 'react-router';

import '../../assets/css/common.css';
import '../../assets/css/sidemenu.css';
import '../../assets/css/timesheet.css';

import NavBar from "../../components/nav-bar";
import SideBar from "../../components/sidebar";

function Vehicles() {
    const { id } = useParams();
    const [data, setData] = useState([]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/vendors/${id}`)
            .then(response => response.json())
            .then(json => setData(json.vehicles))
            .catch(error => console.error(error));
    }, [id])

    return (
        <div className="container-fluid px-0 mb-5">
            <main id="main-layout" role="main" className="pb-3">
                <div className="enquiry-page-wrapper">
                    <NavBar title={"Vehicles"} />
                    <div className="container-fluid">
                        <div className="row">
                            <SideBar />

                            <div className="home-section">
                                <div className="col-lg-12 mb-2 pb-2" id="logContainer">
                                    {/* <div className="row m-0 justify-content-between align-items-center">
                                        <div className="card-header p-0" style={{ borderBottom: "none" }}>
                                            <ul className="nav nav-tabs justify-content-start common-view-tabs" role="tablist">
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link active common-view-link" data-status-id="0"
                                                        id="nav-Current-tab" data-toggle="tab" href="#nav-Current"
                                                        role="tab" aria-controls="nav-Current"
                                                        aria-selected="true">Scheduler</a>
                                                </li>
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link common-view-link" data-status-id="1"
                                                        id="nav-History-tab" data-toggle="tab" href="#nav-History"
                                                        role="tab" aria-controls="nav-History"
                                                        aria-selected="true">History</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6 top-right d-flex justify-content-end align-items-end"
                                            style={{ gap: "10px" }}>
                                            <div className="container-fluid">
                                                <input className="Enquiry-form-control" type="search" id="searchInput"
                                                    placeholder="Search by Process" />
                                            </div>
                                            <div className="d-flex" style={{ gap: "10px" }}>
                                                <div>
                                                    <a role="button" className="c-black" href="/temp/Production Schedule.xlsx"
                                                        title="Download Report">
                                                        <i className="f-24 i-btn cursor-pointer ti ti-download"></i>
                                                    </a>
                                                </div>
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip"
                                                    title="Filter" onClick="openSideFilterPanel()">
                                                    <i id="filter-icon" className="f-24 i-btn cursor-pointer ti ti-filter"></i>
                                                </a>
                                            </div>
                                            <div id="plan-insert-record">
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip" title="Add"
                                                    onClick="insertRowSchedule()">
                                                    <i className="f-24 i-btn cursor-pointer ti ti-table-plus"></i>
                                                </a>
                                            </div>
                                            <div id="plan-upload-record">
                                                <input type="file" id="excelFileInput" accept=".xlsx, .xls"
                                                    style={{ display: "none" }} onchange="excelFileUpload()" />
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip"
                                                    title="Upload"
                                                    onClick="document.getElementById('excelFileInput').click();">
                                                    <i className="f-24 i-btn cursor-pointer ti ti-upload"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="tab-content mt-1" id="nav-tabContent">
                                        <div className="tab-pane fade show active" id="nav-Current" role="tabpanel"
                                            aria-labelledby="nav-Current-tab">
                                            <div id="list_content" className="table-responsive">
                                                <table className="table-list table-hover schedule-table" style={{ width: "100%" }}
                                                    id="plan-schedule-table">
                                                    <thead>
                                                        <tr className="table-list-header-row" style={{ color: "#ffffff" }}>
                                                            <th>Vehicle Type</th>
                                                            <th>Vehicle Number</th>
                                                            <th>Capacity</th>
                                                            <th>Avg. Distance/Day</th>
                                                            <th>Location</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="table-list-body">
                                                        {data.map((dt, i) =>
                                                            <tr className="table-list-body-row collapse plan-schedule-row show"
                                                                id={`row-` + i} key={i} data-id="1">
                                                                <td data-type="text" name="vendor_type">
                                                                    {dt.type}
                                                                </td>
                                                                <td data-type="text" name="vehicle_number">{dt.vehicle_number}</td>
                                                                <td data-type="text" name="capacity">{dt.capacity}</td>
                                                                <td data-type="text" name="avg_distance_per_day">{dt.avg_distance_per_day}</td>
                                                                <td data-type="text" name="location">
                                                                    {`${dt.location.lat}, ${dt.location.lng}`}
                                                                </td>
                                                            </tr>)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
export default Vehicles;